import { useI18n } from 'hooks/useI18n';
import SectionChart from '../shared/sectionChart/SectionChart';
import LocationOffered from './charts/LocationOffered';
import MostOfferedPerks from './charts/MostOfferedPerks';
import MostWantedRoles from './charts/MostWantedRoles';
import SalaryOfferedVsWanted from './charts/SalaryOfferedVsWanted';
import { StyledSection } from './Companies.styled';
import SectionHeroBoxes from '../shared/sectionHeroBoxes/SectionHeroBoxes';

const Companies: React.FC = () => {
  const { t } = useI18n('developer-career-report-2025');

  return (
    <StyledSection>
      <SectionHeroBoxes
        boxOne={{
          text: t('mantechcar25.companies.hero.title'),
          color: '#b3a2f1'
        }}
        boxTwo={{
          text: t('mantechcar25.companies.hero.desc'),
          color: '#7d64d6'
        }}
        boxThree={{
          text: t('mantechcar25.companies.hero.descExtra'),
          color: '#e6dfff'
        }}
      />
      <SectionChart
        title={t('mantechcar25.companies.salary-offered-wanted.title')}
        desc={t('mantechcar25.companies.salary-offered-wanted.desc')}
        descExtra={t('mantechcar25.companies.salary-offered-wanted.descExtra')}
        shareId="salaryofferedvswanted"
        emailSubject={t(
          'mantechcar25.share-modal.salary-offered-wanted.email-subject'
        )}
        emailMessage={t(
          'mantechcar25.share-modal.salary-offered-wanted.email-text'
        )}
        shareMessage={t('mantechcar25.share-modal.salary-offered-wanted.text')}
      >
        <SalaryOfferedVsWanted />
      </SectionChart>
      <SectionChart
        title={t('mantechcar25.companies.most-wanted-roles.title')}
        desc={t('mantechcar25.companies.most-wanted-roles.desc')}
        descExtra={t('mantechcar25.companies.most-wanted-roles.descExtra')}
        shareId="mostwantedroles"
        emailSubject={t(
          'mantechcar25.share-modal.most-wanted-roles.email-subject'
        )}
        emailMessage={t(
          'mantechcar25.share-modal.most-wanted-roles.email-text'
        )}
        shareMessage={t('mantechcar25.share-modal.most-wanted-roles.text')}
      >
        <MostWantedRoles />
      </SectionChart>
      <SectionChart
        title={t('mantechcar25.companies.most-offered-perks.title')}
        desc={t('mantechcar25.companies.most-offered-perks.desc')}
        descExtra={t('mantechcar25.companies.most-offered-perks.descExtra')}
        shareId="mostofferedperks"
        emailSubject={t(
          'mantechcar25.share-modal.most-offered-perks.email-subject'
        )}
        emailMessage={t(
          'mantechcar25.share-modal.most-offered-perks.email-text'
        )}
        shareMessage={t('mantechcar25.share-modal.most-offered-perks.text')}
      >
        <MostOfferedPerks />
      </SectionChart>
      <SectionChart
        title={t('mantechcar25.companies.locations-offered.title')}
        desc={t('mantechcar25.companies.locations-offered.desc')}
        shareId="locationoffered"
        emailSubject={t(
          'mantechcar25.share-modal.locations-offered.email-subject'
        )}
        emailMessage={t(
          'mantechcar25.share-modal.locations-offered.email-text'
        )}
        shareMessage={t('mantechcar25.share-modal.locations-offered.text')}
      >
        <LocationOffered />
      </SectionChart>
    </StyledSection>
  );
};

export default Companies;
